<template>
  <div class="c-trackplan">
    <track-plan-filter ref="queryFormRef" @on-search="filterData" />
    <div class="c-m-table">
      <div class="table-btns-row">
        <div class="btns-row">
          <ElDropdown @command="batchActions">
            <ElButton>
              批量操作
              <i class="el-icon-arrow-down el-icon--right"></i>
            </ElButton>
            <ElDropdownMenu slot="dropdown">
              <ElDropdownItem command="whiteListAdd" v-if="hasOperateWhiteList">添加包体更新白名单</ElDropdownItem>
              <ElDropdownItem command="whiteListDel" v-if="hasOperateWhiteList">移除包体更新白名单</ElDropdownItem>
              <ElDropdownItem command="exportTrackPLan">导出追踪计划</ElDropdownItem>
              <ElDropdownItem command="selectMaterial">选择素材</ElDropdownItem>
              <ElDropdownItem command="selectPage">选择落地页</ElDropdownItem>
              <ElDropdownItem command="selectAgent">修改代投账号</ElDropdownItem>
            </ElDropdownMenu>
          </ElDropdown>
          <ElButton @click="downAmountEntryTmp">消耗/赠款录入模板</ElButton>
          <ElButton style="margin-left: 0" @click="downImageBindTmp">批量素材模板下载</ElButton>
          <ElUpload
            v-if="hasReportImport"
            action=""
            :before-upload="preUploadPtomData"
            accept="application/vnd.ms-excel,.xls,.xlsx,.csv"
            style="display: inline-block"
          >
            <ElButton>消耗/赠款报表导入</ElButton>
          </ElUpload>
          <ElUpload
            v-if="hasImageBindImport"
            action=""
            :before-upload="preImageBandingData"
            accept="application/vnd.ms-excel,.xls,.xlsx,.csv"
            style="display: inline-block"
          >
            <ElButton class="upload-btn">素材绑定导入</ElButton>
          </ElUpload>
          <ElButton @click="iOSTakeDownModal = true" v-if="hasIOSTakeDownRemind">iOS下架监控提醒</ElButton>
          <ElButton style="margin-left: 0" @click="amountReCalcModal = true" v-if="hasGiveAmountCalc">赠款消耗重算</ElButton>
          <ElButton style="margin-left: 0" v-if="hasTencentGameDataHelperPermit" @click="showTencentGameDataHelperDrawer = true">
            腾讯游戏数据助攻
          </ElButton>
          <ElButton style="margin-left: 0" v-if="hasPopularGameConfigPermit" @click="showCommonlyGameConfigModal = true">
            常用游戏管理
          </ElButton>
        </div>

        <div class="add">
          <ElButton @click="showCustomTableColumnModal = true">自定义列</ElButton>
          <ElButton type="primary" v-if="hasOperateTrackPlan" @click="openCreatePlanRoute">新建追踪计划</ElButton>
        </div>
      </div>
      <Viewport v-model="tableHeight">
        <track-plan-table
          v-loading="tableLoading"
          :data="tableList"
          :columns="tableCols"
          :height="tableHeight"
          @on-select="setSelectList"
          @on-show="showDetailDrawerModal"
          @on-plan-copy="openCreatePlanRoute"
          @on-quick-debug="openQuickDebugModal"
          @on-plan-edit="openPlanEditModal"
          @on-data-entry="openDataEntryModal"
          @on-account-edit="openAccountModifyModal"
          @on-proxy-control="openProxyControlModal"
          @on-media-plan-id="openMediaPlanIdModal"
          @on-image-bind="imageBind"
          @on-page-bind="pageBind"
          @on-image-cancel-bind="cancelImagePlanBind"
          @on-page-cancel-bind="cancelPagePlanBind"
          @create-retry-huawei-extend-pkg="onCreateHuaweiExPkg"
        />

        <div class="pager">
          <el-pagination
            :total="total"
            :current-page.sync="pager.pageIndex"
            :page-size.sync="pager.pageSize"
            :page-sizes="[10, 40, 60, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="changePageIndex"
            @size-change="changePageSize"
            class="pager"
            background
          />
        </div>
      </Viewport>
    </div>

    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      name="TrackPlanCustomColumn"
      v-model="showCustomTableColumnModal"
      :data="rawTableCols"
      :sub-title="['基础信息']"
      @on-select="onTableColsChange"
    />

    <!-- iOS下架监控提醒 -->
    <ios-take-down v-model="iOSTakeDownModal" />
    <!-- 赠款消耗重算 -->
    <amount-re-calc v-model="amountReCalcModal" @on-refresh="filterData" />
    <!-- 快速联调 -->
    <quick-debug v-model="quickDebugModal" :plan-info="planInfo" />
    <!-- 编辑 -->
    <plan-edit v-model="planEditModal" :plan-info="planInfo" @on-refresh="filterData" />
    <!-- 数据录入 -->
    <data-entry v-model="dataEntryModal" :plan-info="planInfo" @on-refresh="filterData" />
    <!-- 账号修改 -->
    <account-modify v-model="accountModifyModal" :plan-info="planInfo" @on-refresh="filterData" />
    <!-- 代投扣量 -->
    <proxy-control-config v-model="proxyControlModal" :plan-info="proxyControlInfo"></proxy-control-config>
    <!-- 媒体计划ID/关键词ID/广告主ID -->
    <media-plan-id v-model="mediaPlanIdModal" :info="mediaPlanIdInfo" @on-refresh="filterData" />
    <!-- 选择素材列表 -->
    <pick-material v-model="pickImageModal" @on-select="pickMaterialSelect" />
    <!-- 选择落地页列表 -->
    <land-page v-model="pickPageModal" @on-select="pickPageSelect" />

    <!-- 计划详情数据 -->
    <DetailsDrawer v-model="showDetailsDrawer" :info="drawerInfo"> </DetailsDrawer>

    <!-- 腾讯广告游戏数据助攻 -->
    <TencentGameDataHelperDrawer v-model="showTencentGameDataHelperDrawer"></TencentGameDataHelperDrawer>
    <!-- 常用游戏管理 -->

    <CommonlyGameConfigModal :visible.sync="showCommonlyGameConfigModal">
      <el-button @click="onCommonlyGamesConfigModalClose">取 消</el-button>
      <el-button type="primary" :loading="commonlyGamesConfigSubmitLoading" @click="onCommonlyGamesConfigConfirm">确 定</el-button>
    </CommonlyGameConfigModal>

    <el-dialog
      custom-class="agent-form-modal"
      width="360px"
      title="批量修改代投账号"
      :visible.sync="agentFormModal"
      @closed="closeAgentFormModal"
    >
      <el-form ref="agent-account-form" label-width="100px">
        <el-form-item label="已选计划">
          <span>{{ selectList.length }}个</span>
        </el-form-item>

        <el-form-item label="修改代投账号">
          <el-select v-model="agentForm.accountId" filterable clearable placeholder="选择账号">
            <el-option v-for="item in AGENTS_DATA" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clearAgentAccounts" :loading="agentForm.agentClearLaoding">清空账号</el-button>
        <el-button @click="closeAgentFormModal">取 消</el-button>
        <el-button type="primary" :loading="agentForm.agentSubmitLoading" @click="onAgentModalConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { Message } from 'view-design'
import { useRouter } from 'vue-router/composables'
import { cancelPlanImage, cancelPlanPage, batchCheckMaterial, batchUpdatePlanPage, createHuaweiExPkg } from '@/api/track.plan.model'

import TencentGameDataHelperDrawer from './components/game-data-helper.vue'
import TrackPlanFilter from './components/track-plan-filter.vue'
import TrackPlanTable from './components/track-plan-table.vue'
import DetailsDrawer from '@/views/promote/plandata/components/details-drawer'
import CustomColumn from '@/components/converter/custom-column2.vue'
import IosTakeDown from './components/ios-take-down'
import AmountReCalc from './components/amount-re-calc'
import MediaPlanId from './components/media-plan-id.vue'
import QuickDebug from './components/quick-debug'
import PlanEdit from './components/plan-edit'
import AccountModify from './components/account-modify.vue'
import ProxyControlConfig from './components/proxy-control-config.vue'
import DataEntry from './components/data-entry.vue'
import PickMaterial from '@/components/material/material.vue'
import LandPage from '@/components/landpage/landpage'
import CommonlyGameConfigModal from './components/commonly-games-config/index.vue'
import {
  useTrackPlanTable,
  usePageAccess,
  usePlanDetailDrawer,
  useAgentAccount,
  useFilesAction,
  useCommonlyGameConfig
} from './hooks/useTable.js'

import { initPageData, AGENTS, MID_GAMES } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([AGENTS, MID_GAMES])

const AGENTS_DATA = computed(PAGE_REQUIRED_OPTS.AGENTS)
const MID_GAMES_DATA = computed(PAGE_REQUIRED_OPTS.MID_GAMES)

const router = useRouter()

const queryFormRef = ref(null)
const tableCustomColsRef = ref(null)

// Data
const showTencentGameDataHelperDrawer = ref(false)
const iOSTakeDownModal = ref(false)
const amountReCalcModal = ref(false)
const quickDebugModal = ref(false)
const planEditModal = ref(false)
const dataEntryModal = ref(false)
const accountModifyModal = ref(false)
const mediaPlanIdModal = ref(false)
const proxyControlModal = ref(false)
const pickImageModal = ref(false)
const pickPageModal = ref(false)
const mediaPlanIdInfo = ref({})
const proxyControlInfo = ref({})
const planInfo = ref({})
const planIds = ref([])

/**
 * @description: 表格数据及自定义列
 * @return {*}
 */
const {
  tableLoading,
  tableCols,
  tableHeight,
  onTableColsChange,
  showCustomTableColumnModal,
  rawTableCols,
  tableList,
  total,
  pager,
  changePageIndex,
  changePageSize,
  filterData,
  getData,
  selectList,
  setSelectList,
  trackPlanTableActions
} = useTrackPlanTable(queryFormRef)

/**
 * @description: 页面权限
 * @return {*}
 */
const {
  hasReportImport,
  hasTencentGameDataHelperPermit,
  hasImageBindImport,
  hasIOSTakeDownRemind,
  hasGiveAmountCalc,
  hasOperateWhiteList,
  hasOperateTrackPlan,
  hasPopularGameConfigPermit
} = usePageAccess()

const { drawerInfo, showDetailsDrawer, showDetailDrawerModal } = usePlanDetailDrawer()
const { agentForm, agentFormModal, selectAgent, onAgentModalConfirm, closeAgentFormModal, clearAgentAccounts } = useAgentAccount(
  selectList,
  getData
)
const { preUploadPtomData, preImageBandingData, downImageBindTmp, downAmountEntryTmp } = useFilesAction(filterData)
const { showCommonlyGameConfigModal, commonlyGamesConfigSubmitLoading, onCommonlyGamesConfigModalClose, onCommonlyGamesConfigConfirm } =
  useCommonlyGameConfig()

const onCreateHuaweiExPkg = (row) => {
  row.retryLoading = true
  createHuaweiExPkg({ planId: row.planId }).then(() => {
    getData()
  })
}

const openCreatePlanRoute = ({ planId }) => {
  if (planId) router.push({ name: 'trackplanadd', query: { t: 'copy', id: planId } })
  else router.push({ name: 'trackplanadd' })
}

const openQuickDebugModal = (row) => {
  planInfo.value = row
  quickDebugModal.value = true
}

const openPlanEditModal = (row) => {
  planInfo.value = row
  planEditModal.value = true
}

const openDataEntryModal = (row) => {
  planInfo.value = row
  dataEntryModal.value = true
}

const openAccountModifyModal = (row) => {
  planInfo.value = row
  accountModifyModal.value = true
}

const openMediaPlanIdModal = (row) => {
  let type = 0
  if (row.mediaId === 225) type = 4
  if (row.mediaId === 193) type = 2
  mediaPlanIdInfo.value = {
    planId: row.planId,
    type,
    mediaId: row.mediaId,
    mediaPlanId: row.mediaPlanId
  }
  mediaPlanIdModal.value = false
  mediaPlanIdModal.value = true
}

const openProxyControlModal = (row) => {
  proxyControlInfo.value = { ...row }
  proxyControlModal.value = true
}

const imageBind = (row) => {
  planIds.value = [row.planId]
  pickImageModal.value = true
}

const pageBind = (row) => {
  planIds.value = [row.planId]
  pickPageModal.value = true
}

const cancelImagePlanBind = (row) => {
  tableLoading.value = true
  cancelPlanImage({ planId: row.planId }).then((data) => {
    tableLoading.value = false
    filterData()
    if (data) Message.success('取消成功')
    else Message.error('取消失败')
  })
}

const cancelPagePlanBind = (row) => {
  tableLoading.value = true
  cancelPlanPage({ planId: row.planId }).then((data) => {
    tableLoading.value = false
    filterData()
    if (data) Message.success('取消成功')
    else Message.error('取消失败')
  })
}

const batchActions = (name) => {
  if (!selectList.value || selectList.value.length === 0) {
    Message.warning('请至少选择一条记录！')
    return
  }

  if (name === 'selectMaterial') {
    selectMaterial()
  } else if (name === 'selectPage') {
    selectPage()
  } else if (name === 'selectAgent') {
    selectAgent()
  } else {
    trackPlanTableActions[name]()
  }
}

function selectMaterial() {
  tableLoading.value = false
  const ids = selectList.value.map((ret) => ret.planId)
  planIds.value = ids
  pickImageModal.value = true
}

const pickMaterialSelect = (material) => {
  const { imageId } = material
  checkMaterial(planIds.value, imageId)
}

const checkMaterial = (planIds, imageId) => {
  batchCheckMaterial({ planIds, imageId }).then((data) => {
    if (data) {
      Message.success('素材绑定成功')
      filterData()
    } else Message.error('素材绑定失败')
  })
}

function selectPage() {
  tableLoading.value = false
  const ids = selectList.value.map((ret) => ret.planId)
  planIds.value = ids
  pickPageModal.value = true
}

const pickPageSelect = (page) => {
  if (!pickPageModal.value) return
  pickPageModal.value = false
  const { land_page_id } = page
  checkPage(planIds.value, land_page_id)
}

const checkPage = (planIds, landingPageId) => {
  batchUpdatePlanPage({ planIds, landingPageId }).then((data) => {
    if (data) {
      Message.success('落地页绑定成功')
      filterData()
    } else Message.error('落地页绑定失败')
  })
}

onMounted(() => {
  getData()
})
</script>

<style lang="scss" scoped>
::v-deep .agent-form-modal {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.c-trackplan {
  position: relative;
}

.c-m-table {
  .table-btns-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .btns-row,
  .add {
    button {
      margin-right: 5px;
    }
  }
}

.c-table-page {
  text-align: right;
  padding: 5px 0;
}

.pager {
  text-align: right;
}
</style>
